import { Tooltip } from "antd";
import { openPopup2 } from "../../../../contexts/PopupContext";
import { callEventTrackingOp, useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { datetime } from "../../../../util/library/datetime";
import { crewTaskName, SHORT_DATETIME_FORMAT, STEP_STATUS } from "../../../../util/varibles/constants";
import { getSubStepStatus } from "../../../../util/varibles/global";
import { TCrewTask } from "../../../../util/varibles/interface";
import LoadingBox from "../../../LoadingBox";
import ConfirmNextState from "../StepControl/ConfirmNextState";

export default function CrewTask({ data, runningTaskId }: { data: TCrewTask; runningTaskId?: string }) {
    const { nextState } = callEventTrackingOp();
    const status = getSubStepStatus(data);
    const statusName = crewTaskName[status] || '';
    const [loading] = useTrackingOp(state => state.loading);

    const handleClick = () => {
        const { id } = data;
        openPopup2(<ConfirmNextState
            isComplete={false}
            name={<>{statusName.toLowerCase()}: {data.description}</>}
            onOk={() => {
                nextState({ crew_task_id: id, state: status, loading: id });
            }}
        />)
    }

    const isDisabled = !!loading || (!!runningTaskId && runningTaskId !== data.id);

    return <div className="flex flex-col items-center text-[14px]" data-status={status} >
        <Tooltip title="Planned Start Time">
            <div className="text-comment italic">
                {datetime(data.est_start_time).format(SHORT_DATETIME_FORMAT)}
            </div>
        </Tooltip>

        {data.real_start_time && (
            <Tooltip title="Actual Start Time">
                {datetime(data.real_start_time).format(SHORT_DATETIME_FORMAT)}
            </Tooltip>
        )}

        <Tooltip title={isDisabled ? "" : statusName}>
            <div
                className={`flex relative justify-center items-center rounded-full border px-4 py-1 h-[36px] my-1 font-[600] ${status === STEP_STATUS.NOT_START
                    ? `bt-ghost ${isDisabled ? "cursor-not-allowed bg-[--bgSidebar1] text-[--colorDisable]" : ""}`
                    : status === STEP_STATUS.STARTED
                        ? `border-[--colorActive] bg-[--colorHover] text-[--fontActive] transition-colors duration-300 ${loading
                            ? "cursor-not-allowed"
                            : "cursor-pointer "
                        }`
                        : "border-[--border2] bg-[--bgDisable] text-[--colorDisable] cursor-not-allowed"
                    }`}
                onClick={!isDisabled && status !== STEP_STATUS.COMPLETED ? handleClick : undefined}
                data-disabled={isDisabled}
            >
                {loading === data.id && <LoadingBox className="mr-1" loading spinnerSize={18} />}
                {data.description}
            </div>
        </Tooltip>

        <Tooltip title="Planned Finish Time">
            <div className="text-comment italic">
                {datetime(data.est_finish_time).format(SHORT_DATETIME_FORMAT)}
            </div>
        </Tooltip>

        {data.real_finish_time && (
            <Tooltip title="Actual Finish Time">
                {datetime(data.real_finish_time).format(SHORT_DATETIME_FORMAT)}
            </Tooltip>
        )}
    </div>
}